import i18n from "./i18n";

// 菜单友好名：后端菜单文案不统一（术语漂移、拼写如 IDard），
// 这里按「路径/组件名」→「组件名」优先级查 locales 的 menu.* 命名空间，
// 命中则用清晰措辞覆盖显示（后端数据本身不动），未命中回退后端原名。
export const resolveMenuName = node => {
  if (!node) {
    return "";
  }
  if (node.component) {
    const dir = String(node.path || "").replace(/^\//, "");
    const candidates = [`menu.${dir}/${node.component}`, `menu.${node.component}`];
    for (const key of candidates) {
      // 当前语言未命中时再查回退语言（locale 未设置/小语种时仍生效）
      if (i18n.te(key) || i18n.te(key, "en_US")) {
        return i18n.t(key);
      }
    }
  }
  return node.name || "";
};

export default { resolveMenuName };
